export default __webpack_public_path__ + "static/media/area-3.c50444a7.jpg";